import { GetterTree } from "vuex";
import { RootState } from "../types";
import { OrderHistoryState } from "./types";

export const getters: GetterTree<OrderHistoryState, RootState> = {};
